import React, { useMemo, useState } from 'react';

import { TimePicker } from '@atlaskit/datetime-picker';

import { DEFAULT_TIMES } from '../../constants';
import { type TimeRange } from '../../types';

import { DEFAULT_VALUE } from './constants';
import { Container, Inner, Label } from './styled';
import { type TimeIntervalProps } from './types';
import { getFormattedRange, isValidRange } from './utils';

const TimeInterval: React.FC<TimeIntervalProps> = ({
	id,
	labels,
	defaultValue = DEFAULT_VALUE,
	value: propValue,
	onChange,
	...restProps
}) => {
	const [internalValue, setInternalValue] = useState<TimeRange>(
		propValue !== undefined ? propValue : defaultValue,
	);

	const startId = `start-${id}`;
	const endId = `end-${id}`;

	const onStartChange = (item: string) => {
		if (item) {
			const [startHour, startMinute] = item.split(':');

			const next = {
				...internalValue,
				startHour: parseInt(startHour),
				startMinute: parseInt(startMinute),
			};

			// NOTE: Previously changed here because suspected that It was wrong to have side effects in set state updater function
			// Revert if not a problem
			onChange(next);
			setInternalValue(next);
		}
	};

	const onEndChange = (item: string) => {
		if (item) {
			const [endHour, endMinute] = item.split(':');

			const next = {
				...internalValue,
				endHour: parseInt(endHour),
				endMinute: parseInt(endMinute),
			};

			// NOTE: Previously changed here because suspected that It was wrong to have side effects in set state updater function
			// Revert if not a problem
			onChange(next);
			setInternalValue(next);
		}
	};

	/*
	 * NOTE
	 * If propValue is provided than act as a controlled component,
	 * else act as an uncontrolled component using the value from state
	 */
	const [start, end] = useMemo(() => {
		if (propValue !== undefined && isValidRange(propValue)) {
			return getFormattedRange(propValue);
		}

		return getFormattedRange(internalValue);
	}, [internalValue, propValue]);

	return (
		<Container>
			<Inner>
				<Label htmlFor={startId}>{labels.start}</Label>
				<TimePicker
					{...restProps}
					id={startId}
					name={startId}
					times={DEFAULT_TIMES}
					onChange={onStartChange}
					selectProps={{
						isClearable: false,
					}}
					// time picker doesn't accept defaultValue if value exist.
					// even if value === undefined.
					// so this is workaround to make defaultValue work.
					{...(start && { value: start })}
				/>
			</Inner>
			<Inner>
				<Label htmlFor={endId}>{labels.end}</Label>
				<TimePicker
					{...restProps}
					id={endId}
					name={startId}
					times={DEFAULT_TIMES}
					onChange={onEndChange}
					selectProps={{
						isClearable: false,
					}}
					// time picker doesn't accept defaultValue if value exist.
					// even if value === undefined.
					// so this is workaround to make defaultValue work.
					{...(end && { value: end })}
				/>
			</Inner>
		</Container>
	);
};

export { TimeInterval };
